<template>
  <ValidationObserver ref="form" v-slot="{ passes, dirty}" tag="div" class="setting-block">
    <v-form @submit.prevent="passes(onSubmit)">
      <v-card>
        <v-toolbar class="elevation-0" color="blue lighten-5">
          <v-toolbar-title>Профиль</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn color="success"
                     type="submit"
                     small
                     fab
                     depressed
                     v-on="on"
                     :disabled="!dirty && !avatarChanged"
              >
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Сохранить изменения</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12" sm="4" md="3" class="pb-0">
              <ValidationProvider name="avatar"
                                  v-slot="{  }"
                                  tag="div"
                                  class="setting-avatar"
              >
                <div class="avatar-image" v-if="avatar || newAvatar"
                     :style="{backgroundImage: `url(${avatarSrc})`}"></div>
                <label class="avatar-add">
                  <input type="file"
                         accept="image/png, image/jpeg"
                         name="avatar"
                         @change="onAvatarChange">
                  <span v-if="avatar || newAvatar">Изменить аватар</span>
                  <v-icon v-else>mdi-plus</v-icon>
                </label>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="8" md="9" class="py-0">
              <v-row>
                <v-col cols="12" md="6" class="pb-0">
                  <ValidationProvider name="name"
                                      rules="required"
                                      v-slot="{ errors }"
                                      tag="div"
                  >
                    <v-text-field
                      type="text"
                      v-model="name"
                      label="Имя"
                      :error-messages="errors"
                      outlined
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="pb-0">
                  <ValidationProvider name="email"
                                      rules="required"
                                      v-slot="{ errors }"
                                      tag="div"
                  >
                    <v-text-field
                      type="text"
                      v-model="email"
                      label="Email"
                      :error-messages="errors"
                      outlined
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="pb-0">
                  <ValidationProvider name="password"
                                      mode="passive"
                                      rules="confirmed:password_confirmation"
                                      v-slot="{ errors }"
                                      tag="div"
                  >
                    <v-text-field
                      type="password"
                      autocomplete="new-password"
                      v-model="password"
                      label="Новый пароль"
                      :error-messages="errors"
                      outlined
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="pb-0">
                  <ValidationProvider vid="password_confirmation"
                                      v-slot="{ errors }"
                                      tag="div"
                  >
                    <v-text-field
                      type="password"
                      autocomplete="new-password"
                      v-model="password_confirmation"
                      label="Повторите пароль"
                      :error-messages="errors"
                      outlined
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>
  </ValidationObserver>
</template>

<script>
  import profileApi from '../api/profile.api';

  export default {
    name    : 'SettingsProfile',
    data() {
      return {
        name                 : '',
        email                : '',
        avatar               : null,
        newAvatar            : null,
        avatarChanged        : false,
        password             : '',
        password_confirmation: '',
      };
    },
    computed: {
      avatarSrc() {
        return this.newAvatar ? this.newAvatar : this.avatar.url;
      }
    },
    created() {
      this.name   = this.$auth.user().name;
      this.email  = this.$auth.user().email;
      this.avatar = this.$auth.user().avatar;
    },
    methods : {
      onSubmit() {
        const params = {
          name : this.name,
          email: this.email,
        };

        if (this.avatarChanged) {
          params['avatar'] = this.newAvatar || '';
        }

        if (this.password.length) {
          params['password']              = this.password;
          params['password_confirmation'] = this.password_confirmation;
        }

        this.$store.commit('setLoading', true);
        this.$refs.form.reset();

        profileApi.update(params).then(({ data }) => {
          this.$auth.user(data.data);
        }).catch(({ response }) => {
          this.$refs.form.setErrors(response.data.errors);
        }).finally(() => {
          this.$store.commit('setLoading', false);
        });
      },
      onAvatarChange(event) {
        this.avatarChanged = true;

        const input = event.target;
        const file  = input.files[0];
        if (!file) return false;

        const reader  = new FileReader();
        reader.onload = () => {
          this.newAvatar = reader.result;
        };
        reader.readAsDataURL(file);
      }
    }
  };
</script>

<style lang="scss">

  .setting-avatar {
    position: relative;
    border: 1px solid #ccc;
    max-width: 154px;
    border-radius: 4px;
    background-color: #fafafa;

    .viewport-xs & {
      max-width: none;
      margin-bottom: 30px;
    }


    &:before {
      content: '';
      display: block;
      padding-bottom: 100%;
    }


    .avatar-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      border-radius: 4px;
    }


    .avatar-add {
      cursor: pointer;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      padding: 0;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      &:hover {
        span {
          opacity: 1;
        }
      }

      input {
        appearance: none;
        display: block;
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        width: 0;
        height: 0;
        opacity: 0;
      }

      span {
        display: block;
        opacity: 0;
        transition: opacity 0.2s ease;
        padding: 2px 8px;
        border-radius: 18px;
        background-color: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
      }
    }
  }
</style>
